var arrayWithoutHoles = require("./arrayWithoutHoles");

var iterableToArray = require("./iterableToArray");

var nonIterableSpread = require("./nonIterableSpread");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/toConsumableArray.js
// module id = 228
// module chunks = 28901507966785 35783957827783